export const IMAGE_LIST = {
  // 中旅总社(上海)LOGO
  'logo-cts-sha': 'https://image.ctssha.com/file/2022/10/25/K6DktSde7ukOZRiWGE.png',
  // 星玩家LOGO
  'logo-planet': 'https://image.ctssha.com/file/2023/04/18/VBaIUALHzoO5y3mo8y.png',
  // 中国旅游集团成员LOGO
  'logo-company': 'https://image.ctssha.com/file/2022/10/25/7sKjEY66wMn1IbkhT9.png',
  // 中国旅游集团成员+中旅总社(上海)LOGO
  'logo-companies': 'https://image.ctssha.com/file/2022/07/26/Updj3BUq1xh4XsZzX8.png',
  'bg-distribution-special': 'https://image.ctssha.com/file/2022/11/28/dzT3eN06PPHFbT8zmO.png',
  // 黄色的圆形logo
  'logo-new-circle': 'https://image.ctssha.com/file/2022/11/30/JjvjEcxa7DjKFF9qVp.png',
  // 关于我们 - banner图片
  'banner-about': 'https://image.ctssha.com/file/2022/07/26/jXuGJ4uZsZbBu7XqpZ.png',
  // 关于我们 - 黄色背景图
  'bg-about': 'https://image.ctssha.com/file/2022/11/30/c5ZrpLBwZLxYuBd59U.png',
  // 补给站 - 背景图(大)
  'bg-depot-big': 'https://image.ctssha.com/file/2022/11/30/HkW5iWPnrjaVi1SHTa.png',
  // 补给站 - 背景图
  'bg-depot': 'https://image.ctssha.com/file/2022/11/30/j3dBOzi1pkWrov6euv.png',
  // 签证材料样图
  'default-visa-material-sample': 'https://image.ctssha.com/file/2022/12/01/HdCt1PckrwoOum0K7g.png',
  'default-search': 'https://image.ctssha.com/file/2022/11/30/qOeHo2UxseW1ogshPX.png',
  'default-address': 'https://image.ctssha.com/file/2022/12/06/XjVC6Bmi8TYqbcPyVV.png',
  'default-audit-fail': 'https://image.ctssha.com/file/2022/12/06/Tc0TTV5EEvURJZyiER.png',
  'default-audit-success': 'https://image.ctssha.com/file/2022/12/06/QQN3xWbtUvDNw5R31D.png',
  'default-client': 'https://image.ctssha.com/file/2022/12/06/jIvz1qmxlmfug02TNQ.png',
  'default-coupon': 'https://image.ctssha.com/file/2022/12/06/MpsB4l2mINDJZ9luGq.png',
  'default-distribution-in': 'https://image.ctssha.com/file/2022/12/06/SdCvMJEKwlvKne8U7L.png',
  'default-distribution-out': 'https://image.ctssha.com/file/2022/12/06/CrXuQeE2gzFc9bj4ZO.png',
  'default-distribution-withdraw': 'https://image.ctssha.com/file/2022/12/06/9TeH74kMcwmLICoX8u.png',
  'default-order': 'https://image.ctssha.com/file/2022/12/06/yzlTrD8EeT9p7KTrtL.png',
  'default-team': 'https://image.ctssha.com/file/2022/12/06/3RwHD4CF1RehQhdYXD.png',
  'default-traveler': 'https://image.ctssha.com/file/2022/12/06/IekKWxxQbOBOyBOgnX.png',
  'order-icon-cxdd': 'https://image.ctssha.com/file/2022/12/27/0qgWvKG2nLRPoY4MFw.png',
  'order-icon-jddd': 'https://image.ctssha.com/file/2022/12/27/IiEUdM97cZHhpOzgjW.png',
  'order-icon-pqdd': 'https://image.ctssha.com/file/2022/12/27/cmhwrpTtzweM8i35z3.png',
  'order-icon-spdd': 'https://image.ctssha.com/file/2022/12/27/8B5pujIFjQiTM8H5qF.png',
  'order-icon-qzdd': 'https://image.ctssha.com/file/2022/12/27/TLQCYvuFrA6iL7bsFE.png',
  // 签证订单背景图
  'order-visa-bg': 'https://image.ctssha.com/file/2022/11/24/MXbI4IhVQbEo51Jyvn.png',
  'default-city-address': 'https://image.ctssha.com/file/2023/02/08/mwcT5eewLu2lnymDLn.png',
  'hot-img': 'https://image.ctssha.com/file/2023/02/16/zIuIHe9dg0tkslsBCM.png',
  'order-center-warning': 'https://image.ctssha.com/file/2023/02/27/Yl95HJbzhgH8LAyKSV.png',
  'member-header-bg': 'https://image.ctssha.com/file/2023/03/15/0kMRW8ddmhIZhwgk7L.png',
  'small-star': 'https://image.ctssha.com/file/2023/03/15/GIbJKhrvnI4AknucN0.png',
  'integral-store-bg': 'https://image.ctssha.com/file/2023/03/15/O8r4vTYIJDePQxfvYF.png',
  'integral-detail-bg': 'https://image.ctssha.com/file/2023/03/22/bX6g9n6xb71MGTC29i.png',
  'exchange-success-bg': 'https://image.ctssha.com/file/2023/03/29/Ll9qdq27ynXEEjVeUT.png',
  'growth-img-0': 'https://image.ctssha.com/file/2023/03/16/5lETrRiVAEw32gFX6X.png',
  'growth-img-10': 'https://image.ctssha.com/file/2023/03/16/97frmpRb7klyzJbEPs.png',
  'growth-img-250': 'https://image.ctssha.com/file/2023/03/16/T75qURbVapJcSHgQfs.png',
  'growth-img-500': 'https://image.ctssha.com/file/2023/03/16/dfHJiBpWBJM8FRsb42.png',
  'growth-img-2750': 'https://image.ctssha.com/file/2023/03/16/KwxShqVdMrlRbpPE8F.png',
  'growth-img-5000': 'https://image.ctssha.com/file/2023/03/16/WbwGnG6SW615PckyNU.png',
  'growth-img-12500': 'https://image.ctssha.com/file/2023/03/16/jAKmAP0BQfE9K4HgZC.png',
  'growth-img-20000': 'https://image.ctssha.com/file/2023/03/16/0nxGZn7gSDRxyjmnkM.png',
  'growth-img-30000': 'https://image.ctssha.com/file/2023/03/16/dIZCAL4ODsK2QfN4mc.png',
  'growth-img-40000': 'https://image.ctssha.com/file/2023/03/16/ZCJkZM1xuvRyYJWGG0.png',
  'growth-img-70000': 'https://image.ctssha.com/file/2023/03/16/l8qr7NLXTJYS78kFRe.png',
  'growth-img-max': 'https://image.ctssha.com/file/2023/03/16/pHkm7TFQQKbuDHgh6d.png',
  'sign-in-header-bg': 'https://image.ctssha.com/file/2023/03/27/pNTqIvqEDUwFPGkUqL.png',
  /* ----会员中心相关图片---- */
  // 个人中心背景图片(H5商城)
  'mine-bg-shop': 'https://image.ctssha.com/file/2023/04/10/Xix1OoqDOjkVcjs5BL.png',
  'mine-bg-ysf': 'https://image.ctssha.com/file/2022/10/25/FN2soRXuNPVTc0J6A3.png',
  'mine-login-card': 'https://image.ctssha.com/file/2023/04/12/CgB73l1HELAoZ5GKGR.png',
  'mine-spaceman-ysf': 'https://image.ctssha.com/file/2023/04/12/GCfwlWtWLqbQKAEyzS.png',
  // 会员等级卡片
  'level-card-1': 'https://image.ctssha.com/file/2023/04/10/jGl7c9Wm3HeXYhtCYo.png',
  'level-card-2': 'https://image.ctssha.com/file/2023/04/10/yJE5uh5w3giyXWhgkl.png',
  'level-card-3': 'https://image.ctssha.com/file/2023/04/10/N7RwaCFbAX5KdBrPfq.png',
  'level-card-4': 'https://image.ctssha.com/file/2023/04/10/1rnjrW5V7RSItFBAY7.png',
  'level-card-5': 'https://image.ctssha.com/file/2023/04/10/vm5VSYInyD3xvkngwR.png',
  // 默认会员头像
  'default-avatar': 'https://image.ctssha.com/file/2022/08/08/nG5iRjvZcNRLg7EBvV.png',

  // 优惠券相关
  'coupon-expired': 'https://image.ctssha.com/file/2023/04/27/GJpUoBqIG64w0ofpXA.png',
  'coupon-got': 'https://image.ctssha.com/file/2023/04/27/PszsZPBlZHSQ1uyowS.png',
  'coupon-sold-out': 'https://image.ctssha.com/file/2023/04/27/xiIFCG1qbOqFl1BT5J.png',
  'coupon-used': 'https://image.ctssha.com/file/2023/04/27/XUhnSsLynmbiYb85mh.png',

  'icon-collect': 'https://image.ctssha.com/file/2023/05/06/lhoty95br809Zy2lAR.png',
  'icon-collected': 'https://image.ctssha.com/file/2023/05/06/VE8w7MVLdzUibB4wHL.png',
  'icon-collect-tool': 'https://image.ctssha.com/file/2023/05/08/24zDiChr3vlinN9x5V.png',
  'icon-browse': 'https://image.ctssha.com/file/2023/05/09/Tmbpc64No0oiS8nqog.png',
  'icon-share': 'https://image.ctssha.com/file/2024/08/27/0bchzD65aThqQWujVc.png',
  // 中旅总社
  'logo-company-share': 'https://image.ctssha.com/file/2024/08/27/E8RXp3bcwvtT1nG408.png',
  'bg-poster': 'https://image.ctssha.com/file/2024/10/30/AEQiwhse7pfOww8VDx.png',
  // 携宠游
  'pet-order-yfk': 'https://image.ctssha.com/file/2024/03/29/y0T7xkdsw6VMgYmutA.png',
  'pet-order-ywc': 'https://image.ctssha.com/file/2024/03/29/9Wjnf6ebftrGJCWUQI.png',
  'pet-order-dfk': 'https://image.ctssha.com/file/2024/03/29/pGgKPfSSa8ZecMw48L.png',
  'pet-order-dsh': 'https://image.ctssha.com/file/2024/03/29/DDj54DajM4ix8iXJag.png',
  'pet-maomao': 'https://image.ctssha.com/file/2024/04/01/8n2DwFNJYDMgKuBaz4.png',
  'pet-gougou': 'https://image.ctssha.com/file/2024/04/01/AN97GVDVVeYZ82C7Gr.png',
  'pet-qita': 'https://image.ctssha.com/file/2024/04/01/hNOJlVhy9lAJjwKCul.png',
  'pet-face': 'https://image.ctssha.com/file/2024/08/23/g5Q06ChwdAGV11XhR3.jpg',
  'pet-body': 'https://image.ctssha.com/file/2024/08/23/umwya2bOWRVzc7XJfk.jpg',
};